module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/合作与发展banner.f3ee1e8f.png";